<script lang="ts">
	import { afterNavigate, beforeNavigate } from '$app/navigation';

	let isLoading: boolean = false;

	beforeNavigate(({ to }) => (isLoading = !!to?.route.id));
	afterNavigate(() => (isLoading = false));
</script>

<div
	id="content"
	class="bg-white transition-opacity duration-300 ease-in-out"
	class:opacity-50={isLoading}
>
	<slot />
</div>
